<template>
  <div>
    <reason-list v-show="tabType === 1" @handleShow="handleShow" :isIntegral="0" />
    <reason-show v-if="tabType === 2" :rowItem="rowItem" :reasonType="1" @handleShow="handleShow" />
  </div>
</template>

<script>
import reasonList from './list.vue'
import reasonShow from './show.vue'
export default {
  components: { reasonList, reasonShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>